export default "__VITE_ASSET__D_siJf8X__"